module.exports = __webpack_public_path__ + "img/arrow-left-light-ac.bd9d44e8.svg";